module.exports = __webpack_public_path__ + "static/media/phone-hang-up.b9df39e8.svg";